/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsBackgroundSideBySideOptions, FxIdDomainSettingsBackgroundSideBySideOptionsFromJSONTyped, FxIdDomainSettingsBackgroundSideBySideOptionsToJSON, } from './FxIdDomainSettingsBackgroundSideBySideOptions';
export function FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsSideBySideFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsSideBySideFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsSideBySideFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsBackgroundSideBySideOptions(json)) {
        return FxIdDomainSettingsBackgroundSideBySideOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsSideBySideToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsSideBySideToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsSideBySideToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsBackgroundSideBySideOptions(value)) {
        return FxIdDomainSettingsBackgroundSideBySideOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsBackgroundOptionsSideBySide.js.map